module.exports = __webpack_public_path__ + "static/media/gbill1.1d3f6206.png";